<template>
  <div 
    v-if="antivirusState === 'hasVirus'"
    class="FileEditPreview text-center my-4 flex flex-col text-bc-blue justify-center items-center relative"
  >
    <aw-icon 
      icon="bug-report" 
      class="w-24 h-24 text-red-600"
    />
    <tippy 
      :content="$t('File has virus')" 
      theme='warning'
      to="parent"
    />
  </div>
  <div 
    v-else
    class="FileEditPreview text-center my-4 flex flex-col text-bc-blue justify-center items-center relative"
  >
    <span
      class="absolute right-1 top-1 z-5"
    >
      <aw-icon
        v-if="antivirusState === 'waiting'"
        v-tippy="$t('File is being checked for viruses')"
        icon="safety-check" 
        class="w-5 h-5 text-gray-400"
      />

      <aw-icon 
        v-else-if="antivirusState === 'checked'"
        v-tippy="$t('File is safe')"
        icon="verified-user" 
        class="w-5 h-5 text-green-600"
      />

      <aw-icon 
        v-if="file.deleted"
        v-tippy="$t('File is deleted')"
        icon="trash" 
        class="w-5 h-5 text-red-600"
      />
    </span>
    
    <file-icon
      v-if="!hasPreview || previewIsLoading"
      :ext="file?.ext" 
      size="large" 
    />
    <img
      v-else
      :src="file?.previews['500x500']"
      alt=""
    />
  </div>
</template>

<script>
import FileState from '../../mixins/FileState'

export default {
  mixins: [
    FileState,
  ],
  props: ['file'],
}
</script>

<style lang="scss" scoped>
.FileEditPreview {
  @apply w-full;

  @screen sm {
    width: calc((100% - 2rem)/3);
  }
}
</style>
